<template>
	<v-container>
		<div v-if="(!loading && finance)">
			<!--header-->
			<v-row justify="start" class="total mb-4">
				<v-col cols="3" class="tabCell text-left">Selected financial indicators</v-col>
				<v-col v-for="i in currentRound" cols="1"
					:key="i"
					class="tabCell text-right">round {{ i }}
				</v-col>
			</v-row>
			<!---table-->
			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Sales (total, USD)</v-col>
				<v-col v-for="i in currentRound" cols="1"
					:key="i" class="tabCell text-right">
					{{ format(finance[`round_${i}`].totalSales) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Cost of goods produced (USD)</v-col>
				<v-col v-for="i in currentRound" cols="1"
					:key="i" class="tabCell text-right">
					{{ format(finance[`round_${i}`].costGoodsProduced) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Incomes from sales of franchise</v-col>
				<v-col cols="1" v-for="i in currentRound"
					class="tabCell text-right"
					:key="i">
					{{ format(finance[`round_${i}`].franchiseIncome) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Gross margin (USD)</v-col>
				<v-col cols="1" v-for="i in currentRound" 
					class="tabCell text-right"
					:class="(finance[`round_${i}`].grossMargin < 0) ? 'error--text' : 'secondary--text'"
					:key="i">
					{{ format(finance[`round_${i}`].grossMargin ) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">% of sales</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ salesPercentage(finance[`round_${i}`]) }}
				</v-col>
			</v-row>

			<v-row justify="start" class="total my-4">Operational expenses</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Marketing</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ format(finance[`round_${i}`].marketingExpenses) }}
				</v-col>
			</v-row>
			
			<!-- <v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Depreciation</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ format(finance[`round_${i}`].costGoodsProduced * 0.12) }}
				</v-col>
			</v-row> -->
			
			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Administrative</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ format(finance[`round_${i}`].costGoodsProduced * 0.02) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">R&D</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ format(finance[`round_${i}`].rdExpenses) }}
				</v-col>
			</v-row>

			<v-row justify="start" class="my-4" no-gutters>
				<v-col cols="3" class="tabCell text-left total">Operational profit (EBIT)</v-col>
				<v-col cols="1" v-for="i in currentRound"
					class="tabCell text-right" :key="i"
					:class="(finance[`round_${i}`].ebit < 0) ? 'error--text' : 'secondary--text'">
					{{ format(finance[`round_${i}`].ebit) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">Income tax (20%)</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ format(incomeTax(finance[`round_${i}`])) }}
				</v-col>
			</v-row>

			<v-row justify="start" class="my-4" no-gutters>
				<v-col cols="3" class="tabCell text-left total">Net Profit (USD)</v-col>
				<v-col cols="1" v-for="i in currentRound"
					class="tabCell text-right total"
					:key="i"
					:class="(finance[`round_${i}`].ebit - incomeTax(finance[`round_${i}`]) < 0) ? 'error--text' : 'secondary--text'">
					{{ format(finance[`round_${i}`].ebit - incomeTax(finance[`round_${i}`])) }}
				</v-col>
			</v-row>

			<v-row justify="start" no-gutters>
				<v-col cols="3" class="tabCell text-left">% of sales</v-col>
				<v-col cols="1" v-for="i in currentRound" class="tabCell text-right" :key="i">
					{{ finalPercentage(finance[`round_${i}`]) }}
				</v-col>
			</v-row>

		</div>
		<v-row v-else justify="center">
			<loader></loader>
		</v-row>

	</v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue'
import numeral from 'numeral'

export default {
	props: ['round', 'gameId', 'company'],
	data() {
		return {
			
		}
	},
	computed: {
		loading() {
			return this.$store.getters.loading;
		},
		currentRound() {
			return this.$store.getters.currentRound;
		},
		finance() {
			if(this.$store.getters.finance) {
				return this.$store.getters.finance[0]
			}
			return null
		},
	},
	methods: {
		//format in numeral
		format(param) {
			return numeral(param).format('0,0[.]00')//
		},
		//format in numeral
		percentageFormat(param) {
			return numeral(param).format('%0,0[.]0')//
		},
		salesPercentage(param) {
			const per = param['grossMargin'] / param['totalSales']

			if (per > 0) {
				return this.percentageFormat(per)
			}
			return ' - '
		},
		incomeTax(param) {
			const tax = param['ebit'] * 0.2
			if (tax > 0) {
				return tax
			}
			return 0
		},
		finalPercentage(param) {
			const res = (param['ebit'] - this.incomeTax(param)) / param['totalSales']

			if (res > 0) {
				return this.percentageFormat(res)
			}

			return ' - '
		}		
	},
	components: {
		Loader
	},
	async mounted() {
		const company = this.$route.query.company

		try {
			await this.$store.dispatch('fetchFinance', company)
		}
		catch(error) {
			await this.$store.dispatch('setError', error.message)
		}
	}
}
</script>